// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Marketers_insights__OcRAE {
  width: 100%;
  border: 1px solid var(--color-primary-2);
  border-radius: 1rem;
  padding: 2rem;
}
.Marketers_insights__OcRAE > * {
  margin-bottom: 2rem;
}
.Marketers_insights__group__DyNbA {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-bottom: 5rem;
}
@media only screen and (max-width: 50em) {
  .Marketers_insights__group__DyNbA {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media only screen and (max-width: 31.25em) {
  .Marketers_insights__group__DyNbA {
    grid-template-columns: 100%;
  }
}

.Marketers_main__FBoSA {
  display: grid;
  grid-template-columns: 72rem 1fr;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  gap: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Marketers_main__FBoSA {
    grid-template-columns: 56rem 1fr;
  }
}
@media only screen and (max-width: 43.75em) {
  .Marketers_main__FBoSA {
    grid-template-columns: 100%;
  }
}
.Marketers_main_nav__Zl9Y4 {
  display: flex;
  justify-content: space-between;
  width: 34rem;
  flex-wrap: wrap;
  margin-top: 4rem;
  background-color: var(--color-white);
  border-bottom: solid 1px var(--color-dark);
  border-radius: 1rem 1rem 0 0;
}
.Marketers_main_nav__Zl9Y4 > :not(:last-child) {
  margin-right: 1rem;
}
.Marketers_main_nav_group__q1nFJ {
  position: relative;
}
.Marketers_main_nav_more__oORdD {
  position: absolute;
  right: 0;
  top: 75%;
  background-color: var(--color-white);
  padding: 1.5rem;
  border-radius: 1rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  z-index: 5;
}
.Marketers_main_nav_more__oORdD > :not(last-child) {
  margin-bottom: 1rem;
}
.Marketers_main_nav_item__7D8a4 {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
}
.Marketers_main_nav_item_active__sXQgu {
  cursor: pointer;
  padding: 1rem 0;
  box-sizing: border-box;
  font-size: var(--default-font-small);
  font-weight: 700;
  color: var(--color-admin-3);
  border-bottom: solid 2px var(--color-admin-3);
}
.Marketers_main_nav_item__7D8a4:hover, .Marketers_main_nav_item__7D8a4:focus, .Marketers_main_nav_item__7D8a4:focus-visible, .Marketers_main_nav_item__7D8a4:focus-within {
  font-weight: 700;
  color: var(--color-admin-3);
  border-bottom: solid 2px var(--color-admin-3);
}

.Marketers_filter__1Xbzv {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  font-size: var(--default-font-small);
  position: relative;
  z-index: 100;
}
.Marketers_filter__1Xbzv > * {
  margin-bottom: 2rem;
}
.Marketers_filter__beside__9f4S5 {
  display: flex;
  gap: 1rem;
  position: absolute;
  top: 20rem;
  left: 4rem;
}
.Marketers_filter__by__SMxI- {
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 1rem;
  padding: 0 1rem;
  padding-bottom: 1rem;
  height: fit-content;
  color: var(--color-dark);
}
.Marketers_filter__by__list__KDQzR {
  padding: 1rem 2rem;
  list-style: none;
  cursor: pointer;
}
.Marketers_filter__by__list__KDQzR:hover {
  background-color: var(--color-grey-3);
  border-radius: 1rem;
}
.Marketers_filter__by__list__active__EF5wD {
  background-color: var(--color-grey-3);
  border-radius: 1rem;
}
.Marketers_filter__action__r9Shi {
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 1rem;
  width: 30rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
}
.Marketers_filter__action__r9Shi > :not(:last-child) {
  margin-bottom: 1rem;
}
.Marketers_filter__action__btns__NJexz {
  display: flex;
  gap: 1rem;
}

.Marketers_tag__oCFPP {
  background-color: var(--color-primary-3);
  font-size: var(--default-font-small);
  height: 4rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  width: 15rem;
  margin-top: 1rem;
  margin-right: 1rem;
}
.Marketers_tag_close__8FtF9 {
  display: block;
  background-color: var(--color-dark);
  color: var(--color-white);
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
}

.Marketers_tags__76otm {
  display: flex;
  flex-wrap: wrap;
}
.Marketers_tags__76otm > :not(:last-child) {
  margin-right: 1rem;
}

.Marketers_singleTag__pirc\\+ {
  display: flex;
  font-size: var(--default-font-small);
  align-items: center;
  background-color: var(--color-grey-5);
  padding: 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  margin-bottom: 0.5rem;
}
.Marketers_singleTag__pirc\\+ > :not(:last-child) {
  margin-right: 0.5rem;
}
.Marketers_singleTag__pirc\\+ > :last-child {
  font-size: 2rem;
}
.Marketers_singleTag__pirc\\+:hover {
  color: var(--color-primary);
}

.Marketers_tagRelative__MfDQZ {
  position: relative;
}

.Marketers_option__5KYGG {
  display: flex;
  justify-content: space-between;
}

.Marketers_card__RJ8RX {
  width: 38rem;
  background-color: var(--color-white);
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
}
@media only screen and (max-width: 62.5em) {
  .Marketers_card__RJ8RX {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Marketers/Marketers.module.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAFJ;AAGI;EALF;IAMI,qCAAA;EAAJ;AACF;AACI;EARF;IASI,2BAAA;EAEJ;AACF;;AAEA;EACE,aAAA;EACA,gCAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,SAAA;AACF;AACE;EARF;IASI,gCAAA;EAEF;AACF;AAAE;EAZF;IAaI,2BAAA;EAGF;AACF;AADE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,0CAAA;EACA,4BAAA;AAGJ;AADI;EACE,kBAAA;AAGN;AAAI;EACE,kBAAA;AAEN;AACI;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,oCAAA;EACA,eAAA;EACA,mBAAA;EACA,4CAAA;EACA,UAAA;AACN;AACM;EACE,mBAAA;AACR;AAGI;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;AADN;AAGM;EACE,eAAA;EACA,eAAA;EACA,sBAAA;EACA,oCAAA;EACA,gBAAA;EACA,2BAAA;EACA,6CAAA;AADR;AAIM;EAIE,gBAAA;EACA,2BAAA;EACA,6CAAA;AALR;;AAaA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,YAAA;AAVF;AAYE;EACE,mBAAA;AAVJ;AAaE;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AAXJ;AAcE;EACE,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EAEA,mBAAA;EACA,wBAAA;AAbJ;AAeI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AAbN;AAeM;EACE,qCAAA;EACA,mBAAA;AAbR;AAgBM;EACE,qCAAA;EACA,mBAAA;AAdR;AAmBE;EACE,oCAAA;EACA,4CAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAjBJ;AAmBI;EACE,mBAAA;AAjBN;AAoBI;EACE,aAAA;EACA,SAAA;AAlBN;;AAuBA;EACE,wCAAA;EACA,oCAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AApBF;AAsBE;EACE,cAAA;EACA,mCAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AApBJ;;AAwBA;EACE,aAAA;EACA,eAAA;AArBF;AAuBE;EACE,kBAAA;AArBJ;;AAyBA;EACE,aAAA;EACA,oCAAA;EACA,mBAAA;EACA,qCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,qBAAA;AAtBF;AAwBE;EACE,oBAAA;AAtBJ;AAyBE;EACE,eAAA;AAvBJ;AA0BE;EACE,2BAAA;AAxBJ;;AA4BA;EACE,kBAAA;AAzBF;;AA2BA;EACE,aAAA;EACA,8BAAA;AAxBF;;AA2BA;EACE,YAAA;EACA,oCAAA;EACA,4CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAxBF;AAyBE;EAPF;IAQI,WAAA;EAtBF;AACF","sourcesContent":["@import \"../variables/breakpoints\";\n\n.insights {\n  width: 100%;\n  border: 1px solid var(--color-primary-2);\n  border-radius: 1rem;\n  padding: 2rem;\n\n  & > * {\n    margin-bottom: 2rem;\n  }\n\n  &__group {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n    margin-bottom: 5rem;\n    @media only screen and (max-width: $bp-800) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    @media only screen and (max-width: $bp-500) {\n      grid-template-columns: 100%;\n    }\n  }\n}\n\n.main {\n  display: grid;\n  grid-template-columns: 72rem 1fr;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  gap: 2rem;\n\n  @media only screen and (max-width: $bp-1000) {\n    grid-template-columns: 56rem 1fr;\n  }\n\n  @media only screen and (max-width: $bp-700) {\n    grid-template-columns: 100%;\n  }\n\n  &_nav {\n    display: flex;\n    justify-content: space-between;\n    width: 34rem;\n    flex-wrap: wrap;\n    margin-top: 4rem;\n    background-color: var(--color-white);\n    border-bottom: solid 1px var(--color-dark);\n    border-radius: 1rem 1rem 0 0;\n\n    & > :not(:last-child) {\n      margin-right: 1rem;\n    }\n\n    &_group {\n      position: relative;\n    }\n\n    &_more {\n      position: absolute;\n      right: 0;\n      top: 75%;\n      background-color: var(--color-white);\n      padding: 1.5rem;\n      border-radius: 1rem;\n      box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n      z-index: 5;\n\n      & > :not(last-child) {\n        margin-bottom: 1rem;\n      }\n    }\n\n    &_item {\n      cursor: pointer;\n      padding: 1rem 0;\n      box-sizing: border-box;\n      font-size: var(--default-font-small);\n\n      &_active {\n        cursor: pointer;\n        padding: 1rem 0;\n        box-sizing: border-box;\n        font-size: var(--default-font-small);\n        font-weight: 700;\n        color: var(--color-admin-3);\n        border-bottom: solid 2px var(--color-admin-3);\n      }\n\n      &:hover,\n      &:focus,\n      &:focus-visible,\n      &:focus-within {\n        font-weight: 700;\n        color: var(--color-admin-3);\n        border-bottom: solid 2px var(--color-admin-3);\n      }\n    }\n  }\n}\n\n// for filter  features\n\n.filter {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: 1rem;\n  font-size: var(--default-font-small);\n  position: relative;\n  z-index: 100;\n\n  & > * {\n    margin-bottom: 2rem;\n  }\n\n  &__beside {\n    display: flex;\n    gap: 1rem;\n    position: absolute;\n    top: 20rem;\n    left: 4rem;\n  }\n\n  &__by {\n    background-color: var(--color-white);\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    border-radius: 1rem;\n    padding: 0 1rem;\n    padding-bottom: 1rem;\n    // max-width: 19rem;\n    height: fit-content;\n    color: var(--color-dark);\n\n    &__list {\n      padding: 1rem 2rem;\n      list-style: none;\n      cursor: pointer;\n\n      &:hover {\n        background-color: var(--color-grey-3);\n        border-radius: 1rem;\n      }\n\n      &__active {\n        background-color: var(--color-grey-3);\n        border-radius: 1rem;\n      }\n    }\n  }\n\n  &__action {\n    background-color: var(--color-white);\n    box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n    border-radius: 1rem;\n    width: 30rem;\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n\n    & > :not(:last-child) {\n      margin-bottom: 1rem;\n    }\n\n    &__btns {\n      display: flex;\n      gap: 1rem;\n    }\n  }\n}\n\n.tag {\n  background-color: var(--color-primary-3);\n  font-size: var(--default-font-small);\n  height: 4rem;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  width: 15rem;\n  margin-top: 1rem;\n  margin-right: 1rem;\n\n  &_close {\n    display: block;\n    background-color: var(--color-dark);\n    color: var(--color-white);\n    width: 16px;\n    height: 16px;\n    line-height: 16px;\n    text-align: center;\n    border-radius: 50%;\n  }\n}\n\n.tags {\n  display: flex;\n  flex-wrap: wrap;\n\n  & > :not(:last-child) {\n    margin-right: 1rem;\n  }\n}\n\n.singleTag {\n  display: flex;\n  font-size: var(--default-font-small);\n  align-items: center;\n  background-color: var(--color-grey-5);\n  padding: 1rem;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n\n  & > :not(:last-child) {\n    margin-right: 0.5rem;\n  }\n\n  & > :last-child {\n    font-size: 2rem;\n  }\n\n  &:hover {\n    color: var(--color-primary);\n  }\n}\n\n.tagRelative {\n  position: relative;\n}\n.option {\n  display: flex;\n  justify-content: space-between;\n}\n\n.card {\n  width: 38rem;\n  background-color: var(--color-white);\n  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n  border-radius: 8px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  @media only screen and (max-width: $bp-1000) {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"insights": `Marketers_insights__OcRAE`,
	"insights__group": `Marketers_insights__group__DyNbA`,
	"main": `Marketers_main__FBoSA`,
	"main_nav": `Marketers_main_nav__Zl9Y4`,
	"main_nav_group": `Marketers_main_nav_group__q1nFJ`,
	"main_nav_more": `Marketers_main_nav_more__oORdD`,
	"main_nav_item": `Marketers_main_nav_item__7D8a4`,
	"main_nav_item_active": `Marketers_main_nav_item_active__sXQgu`,
	"filter": `Marketers_filter__1Xbzv`,
	"filter__beside": `Marketers_filter__beside__9f4S5`,
	"filter__by": `Marketers_filter__by__SMxI-`,
	"filter__by__list": `Marketers_filter__by__list__KDQzR`,
	"filter__by__list__active": `Marketers_filter__by__list__active__EF5wD`,
	"filter__action": `Marketers_filter__action__r9Shi`,
	"filter__action__btns": `Marketers_filter__action__btns__NJexz`,
	"tag": `Marketers_tag__oCFPP`,
	"tag_close": `Marketers_tag_close__8FtF9`,
	"tags": `Marketers_tags__76otm`,
	"singleTag": `Marketers_singleTag__pirc+`,
	"tagRelative": `Marketers_tagRelative__MfDQZ`,
	"option": `Marketers_option__5KYGG`,
	"card": `Marketers_card__RJ8RX`
};
export default ___CSS_LOADER_EXPORT___;
